module.exports = __webpack_public_path__ + "static/media/IOC.cb68b6b1.txt";